<template>
  <div class="modview__grid-item p-4 rounded h-100" @click="openDetails">
    <div class="d-flex">
      <landing-page-modview-grid-mod-icon
        class="d-block"
        :item="item"
        :md-resize="true"
      />
      <div
        class="position-relative ms-4 pe-8 flex-grow-1"
        :data-cy="dataCyName([item.name])"
      >
        <p class="mb-0 lh-sm">
          <b>{{ item.name }}</b>
          <br />
          <span class="text-primary">{{ recommendedRamSize }}</span>
        </p>

        <button
          class="modview__grid-item__btn btn btn-primary btn-sm p-0 position-absolute top-0 end-0"
          type="button"
          aria-label="Open mod details"
          @click="openDetails"
        >
          <fa-icon :icon="faPlus" />
        </button>
      </div>
    </div>

    <landing-page-modview-grid-mod-tags class="mt-2" :tags="item.tags" />
  </div>
</template>

<script lang="ts">
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiMinecraftModpack } from '~/apollo/types/types';
import dataCyName from '~/helpers/cypress';

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<StrapiMinecraftModpack>,
      required: true,
    },
  },
  emits: ['select-mod'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const recommendedRamSize = computed(() =>
      t('general/ram/units/recommended', {
        units:
          props.item.unit === 'MB'
            ? props.item.memory / 1024
            : props.item.memory,
        unitName: 'GB',
      }),
    );

    const openDetails = () => {
      emit('select-mod', props.item);
    };

    return {
      faPlus,

      t,
      recommendedRamSize,
      openDetails,
      dataCyName,
    };
  },
});
</script>

<style scoped lang="scss">
@import 'gportal-theme/scss/_colors.scss';
@import 'bootstrap/scss/mixins/breakpoints';
@import 'gportal-theme/scss/breakpoints.scss';

.modview__grid-item {
  background: rgba($gp-midnight-1, 0.6);
  border: 1px solid transparent;
  transition: border-color 300ms ease-in-out;
  min-height: 12rem;

  @include media-breakpoint-up(md) {
    min-height: auto;
  }

  &:hover {
    border-color: $gp-gportal-green;
    background: $gp-midnight-1;
    cursor: pointer;
  }

  &__btn {
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
